const nicheCalculators = [
  {
    title: "Gold Loan Calculator Online",
    description: "Calculate simple interest on gold loans from SBI, Muthoot, and Manappuram. Get instant EMI for gold loan amounts from 50,000 to 50 lakh.",
    icon: (
      <svg className="w-8 h-8 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    rate: "7% - 12% p.a.",
  },
  {
    title: "Two Wheeler EMI Calculator",
    description: "Planning to buy a bike or scooter? Calculate your two-wheeler loan EMI with rates from HDFC, Bajaj Finance, and IDFC First Bank.",
    icon: (
      <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    rate: "8% - 18% p.a.",
  },
  {
    title: "Washing Machine EMI Calculator",
    description: "Calculate EMI for home appliances like washing machines on no-cost EMI or Bajaj Finserv card. Check monthly installments for brands like LG, Samsung, and Bosch.",
    icon: (
      <svg className="w-8 h-8 text-violet-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    rate: "0% - 24% p.a.",
  },
]

export default function NicheCalculators() {
  return (
    <section id="niche" className="py-16 bg-white scroll-mt-20" aria-labelledby="niche-heading">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 id="niche-heading" className="text-2xl md:text-3xl font-bold text-slate-800 mb-3">
            Niche EMI Calculators
          </h2>
          <p className="text-slate-600 max-w-xl mx-auto">
            Beyond traditional loans, calculate EMIs for gold loans, two-wheelers, and home appliances with accurate Indian bank rates.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {nicheCalculators.map((calc) => (
            <div
              key={calc.title}
              className="border border-slate-200 rounded-2xl p-6 hover:border-blue-200 hover:shadow-lg transition-all group"
            >
              <div className="mb-4">{calc.icon}</div>
              <h3 className="text-lg font-bold text-slate-800 mb-2 group-hover:text-blue-700 transition-colors">
                {calc.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed mb-4">{calc.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-slate-500 bg-slate-50 px-3 py-1 rounded-full">
                  {calc.rate}
                </span>
                <a
                  href="#calculator"
                  className="text-sm font-medium text-blue-700 hover:text-blue-800 flex items-center gap-1"
                >
                  Calculate
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
